import React, { useState } from "react";
import { Link } from "react-router-dom";
import { phoneHyphen } from "../utils/CommonUtils";

import { requestPost } from "../utils/AxiosApi";
import MsgModal from "../modals/MsgModal";

const medmall_header = "/img/medmall_header.png";

const FindPassword = () => {
  //모달창 open
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  const [findInput, setFindInputs] = useState({
    email: "",
    name: "",
    phone: "",
  });
  const { email, name, phone } = findInput;

  const inputChange = (e: any) => {
    const { value, name } = e.target;
    setFindInputsData(name, value);
  };

  const setFindInputsData = (name: any, value: any) => {
    setFindInputs({
      ...findInput,
      [name]: value,
    });
  };

  const tryFindPassword = async () => {
    let data = await requestPost("/api/find/use/account", {
      email: email,
      name: name,
      phone: phone,
    });

    if (data.result === true) {
      setModalOpen(true);
      setModalMsg(
        "가입하신 아이디(이메일)로 비밀번호를 초기화하여 발송하였습니다."
      );

      sendMail();
    } else if (data.result === false) {
      setModalOpen(true);
      setModalMsg("해당 정보의 계정이 존재하지 않습니다.");
    }
  };

  const sendMail = () => {
    requestPost("/api/find/password", {
      email: email,
      name: name,
      phone: phone,
    });
  };

  const phoneValidate = (e: any) => {
    const { value, name } = e.target;
    let phoenNumber = phoneHyphen(value);
    setFindInputsData(name, phoenNumber);
  };

  const findpw = () => {
    if (email === "") {
      setModalOpen(true);
      setModalMsg("찾고 싶은 계정의 아이디를 입력해주세요.");
      return;
    } else if (phone === "") {
      setModalOpen(true);
      setModalMsg("찾고 싶은 계정의 전화번호를 입력해주세요.");
      return;
    } else if (name === "") {
      setModalOpen(true);
      setModalMsg("찾고 싶은 계정의 이름을 입력해주세요.");
      return;
    }
    tryFindPassword();
  };

  const msgModalConfirm = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <div className="display-center-margin-50">
        <div className="find-input">
          <div>
            <div
              className="title_logo_img"
              style={{ textAlign: "center", marginBottom: "35px" }}
            >
              <img src={medmall_header} alt="medmall_header_logo"></img>
            </div>
            <div style={{ marginBottom: "40px" }}>
              <div className="span-blue-40">
                <span id="font-SCD7">비밀번호 찾기</span>
              </div>
            </div>
            <div className="input-form">
              <div className="span-gray-text">
                <span className="input-label">아이디 (이메일)</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="email"
                value={email}
              ></input>
              <div style={{ marginTop: "10px" }}></div>
              <div className="span-gray-text">
                <span className="input-label">이름</span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="name"
                value={name}
              ></input>
              <div style={{ marginTop: "10px" }}></div>
              <div className="input-form">
                <div className="span-gray-text">
                  <span className="input-label">연락처(휴대폰번호)</span>
                </div>
                <input
                  onChange={phoneValidate}
                  className="input-form-w97p-40"
                  type="text"
                  name="phone"
                  value={phone}
                  maxLength={13}
                ></input>
              </div>
            </div>
            <div style={{ marginTop: "40px" }}></div>
          </div>
          <div className="margin-top-bottom-10">
            <Link to="/find/account">
              <span className="span-gray-pointer" id="font-SCD4">
                아이디 찾기
              </span>
            </Link>
            <span className="span-gray-pointer" id="font-SCD4">
              {" "}
              /{" "}
            </span>
            <Link to="/login">
              <span className="span-gray-pointer" id="font-SCD4">
                로그인 페이지
              </span>
            </Link>
          </div>
          <div style={{ marginTop: "40px" }}></div>
          <div className="margin-bottom-40">
            <button
              className="btn-blue-w130"
              type="button"
              onClick={findpw}
              id="font-SCD7"
            >
              확인
            </button>
          </div>
        </div>
      </div>
      {modalOpen && (
        <MsgModal
          setOpenModal={setModalOpen}
          modalMsg={modalMsg}
          modalConfirm={msgModalConfirm}
        ></MsgModal>
      )}
    </div>
  );
};

export default FindPassword;
